import React from "react";
import { Container, Form, Button, Row, Col, Placeholder, Dropdown } from "react-bootstrap";
import { HeadPage, FloatInput, FloatSelect } from "src/componentes";
import RelatorioSistemaCadastroCode from "./RelatorioSistemaCadastro.Code";
import {
  moduloOptions,
  subModuloOptions,
} from "../RelatorioSistema.Dto";

const RelatorioSistemaCadastroView = () => {
  const code = RelatorioSistemaCadastroCode();
  const { register, handleSubmit, formState: { errors } } = code.form;

  return (
    <Container>
      <HeadPage headText={code.id ? "Alterar Relatório" : "Novo Relatório"}>
        {code.id && (
          <>
            <Dropdown.Item onClick={code.handleBaixar}>
              Baixar Relatório
            </Dropdown.Item>
            <Dropdown.Item onClick={code.handleExcluir} className="text-danger">
              Excluir Relatório
            </Dropdown.Item>
          </>
        )}
      </HeadPage>
      
      <Form onSubmit={handleSubmit(code.onSubmit)} className="mt-4">
        {!code.loading ? (
          <>
            <Row className="g-3">
              <Col md={12}>
                <FloatInput
                  label="Nome do Relatório"
                  registerField={register("nome")}
                  errorsMessage={errors.nome}
                />
              </Col>
              <Col md={6}>
                <FloatSelect
                  label="Módulo"
                  options={moduloOptions}
                  register={register("modulo")}
                  errorsMessage={errors.modulo}
                />
              </Col>
              <Col md={6}>
                <FloatSelect
                  label="Submódulo"
                  options={subModuloOptions}
                  register={register("subModulo")}
                  errorsMessage={errors.subModulo}
                />
              </Col>
              <Col md={12}>
                <Form.Group controlId="formFile" className="mb-3">
                  <Form.Label>Arquivo do Relatório (.frx)</Form.Label>
                  <Form.Control
                    type="file"
                    onChange={code.handleFileChange}
                    accept=".frx"
                    isInvalid={!!errors.arquivo}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.arquivo?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} className="d-grid mt-3 mb-5">
                <Button variant="primary" type="submit">
                  Confirmar
                </Button>
              </Col>
            </Row>
          </>
        ) : (
          <Placeholder animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Form>
    </Container>
  );
};

export default RelatorioSistemaCadastroView;
